import BasePresenter from "../../redare/presenter/BasePresenter";
import * as PlatformHttp from "../http/PlatformHttp";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

export default class PlatformPresenter extends BasePresenter {

    /**
     * @param body: {key, platform, id, enabled, incDel}
     * @param query: {curPage,pageSize}
     * @returns Promise
     */
    findPlatformList(body, query, success, fails) {

        if (this._onBeforeFindPlatformList) {
            let data = this._onBeforeFindPlatformList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        PlatformHttp.findPlatformList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindPlatformListSuccess) {
                    result = this._onBeforeFindPlatformListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindPlatformListSuccess) {
                    this.view._onFindPlatformListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {key, platform, id, enabled, incDel}
     * @param query: {}
     * @returns Promise
     */
    findPlatformAll(body, query, success, fails) {

        if (this._onBeforeFindPlatformAll) {
            let data = this._onBeforeFindPlatformAll(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        PlatformHttp.findPlatformAll(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindPlatformAllSuccess) {
                    result = this._onBeforeFindPlatformAllSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindPlatformAllSuccess) {
                    this.view._onFindPlatformAllSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

    /**
     * @param body: {id, platform, userPlatform, type, key, code, admin, defaults, canDel, platformUnionUserPlatform}
     * @param query: {}
     * @returns Promise
     */
    findPlatformRoleList(body, query, success, fails) {

        if (this._onBeforeFindPlatformRoleList) {
            let data = this._onBeforeFindPlatformRoleList(body, query);
            if (!data || typeof data !== 'object') {
                return;
            }
            body = data.body;
            query = data.query;
        }

        PlatformHttp.findPlatformRoleList(body, query).then(
            result => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (success) {
                    success(result);
                    return;
                }

                if (this._onBeforeFindPlatformRoleListSuccess) {
                    result = this._onBeforeFindPlatformRoleListSuccess(result, {body, query});
                }

                if (this.view && this.view._onFindPlatformRoleListSuccess) {
                    this.view._onFindPlatformRoleListSuccess(result, {body, query});
                }
            },
            error => {
                this.closeDoingIndicator();
                this.closeLoadingIndicator();
                this.closeLoadMoreIndicator();

                if (fails) {
                    if(!fails(error)){
                        this.tipError(error);
                    }
                }else{
                    this.tipError(error);
                }
            }
        );
    }

}